import React, { Component } from 'react'
import DeferImage from '../DeferImage'

const easySteps = {
  step1: {
    icon: 'assets/images/hover_on_pencil.svg',
    name: 'Request Service',
    description: 'Tell us what you need serviced',
    image: 'assets/images/calendar-with-car-in-background.svg'
  },
  step2: {
    icon: 'assets/images/hover_on_dollar.svg',
    name: 'Get Multiple Quotes',
    description:
      'AutoMech will work with service providers in your area to get multiple quotes for the service you need',
    image: 'assets/images/multiple-quote-selection.svg'
  },
  step3: {
    icon: 'assets/images/hover_on_check.svg',
    name: 'Finalize Appointment',
    description:
      'You approve the quote before the appointment is finalized and there are absolutely no surprises.',
    image: 'assets/images/satisfied-customer-after-appointment-booking.svg'
  },
  step4: {
    icon: 'assets/images/hover_on_service.svg',
    name: 'Service Valet',
    description:
      'On the day of the appointment, AutoMech will safely pick-up your car, get it serviced and bring it back to you.',
    image: 'assets/images/valet-picking-up-car.svg'
  }
}
class WeMakeItEasy extends Component {
  state = {
    activeStep: easySteps.step1
  }

  activateStep(step) {
    this.setState({ activeStep: step })
  }

  render() {
    return (
      <section className="hero container">
        <div className="hero-head">
          <h1 className="subtitle is-2 has-text-centered">We make it easy</h1>
        </div>
        <div className="hero-body easysteps-padding">
          <div className="tile is-ancestor we-make-it-easy-content">
            <div className="tile is-vertical is-parent">
              {this.renderEasyStep(easySteps.step1)}
              {this.renderEasyStep(easySteps.step2)}
              {this.renderEasyStep(easySteps.step3)}
              {this.renderEasyStep(easySteps.step4)}
            </div>
            {this.renderEasyStepImage()}
          </div>
        </div>
      </section>
    )
  }

  renderEasyStep(stepInfo) {
    const { activeStep } = this.state
    const isCurrentStepActive = activeStep.name === stepInfo.name
    return (
      <div>
        <div className="tile is-child is-hidden-tablet">
          <DeferImage src={stepInfo.image} className="easystep-image" />
          <br />
        </div>
        <div
          onMouseEnter={() => this.activateStep(stepInfo)}
          className={
            'tile is-child easysteps easysteps-center-mobile pointer ' +
            (!isCurrentStepActive ? 'dull' : '')
          }>
          <div className="row easysteps-center-mobile">
            <DeferImage src={stepInfo.icon} className="is-hidden-mobile" alt="Pencil" />
            <div className="content small-padding">
              <h2 className="title is-5 has-text-weight-semibold is-marginless">{stepInfo.name}</h2>
              <p>{stepInfo.description}</p>
            </div>
          </div>
        </div>
        <br />
        <br />
      </div>
    )
  }

  renderEasyStepImage() {
    const { activeStep } = this.state
    return (
      <div className="tile is-parent is-hidden-mobile text-center">
        <div className="tile is-child">
          <DeferImage
            src={activeStep.image}
            alt="Calender with car in background"
            className="easyStepRightImage"
          />
        </div>
      </div>
    )
  }
}

export default WeMakeItEasy



// WEBPACK FOOTER //
// ./src/components/home/WeMakeItEasy.js